import styled from 'styled-components';
import RawBreadcrumb from 'react-bootstrap/Breadcrumb';
import Container from 'react-bootstrap/Container';

import theme from '../../styles/theme';

export const Breadcrumb = styled(RawBreadcrumb)`
  > ol {
    background-color: transparent;

    li.breadcrumb-item::before {
      color: #fff;
    }
  }
`;

export const BreadcrumbItem = styled(RawBreadcrumb.Item)``;

export const Header = styled.header`
  background-color: ${theme.colors.dark_blue};
  min-height: 250;
  padding-bottom: ${({ isOld }) => (isOld ? 0 : 130)}px;
`;

export const Main = styled(Container)`
  margin-top: ${({ isOld }) => (isOld ? 0 : -130)}px;
`;
